// components/SharpWatchMap.js
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { useRef, useEffect } from "react";
import PropTypes from "prop-types";

const markerIcon = new L.Icon({
  iconUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

const deployments = [
  { name: "Venice and Lime Rock: VK-956", lat: 28.8, lng: -88.5 },
  { name: "WhoDat: MC-547", lat: 28.6, lng: -89.0 },
  { name: "Kings Quay: GC-433", lat: 28.2, lng: -90.5 },
  { name: "Shenandoah: WR-52", lat: 27.9, lng: -91.0 },
];

export default function SharpWatchMap({ activeMarkerName, onMarkerClick }) {
  const markerRefs = useRef({});

  useEffect(() => {
    Object.entries(markerRefs.current).forEach(([name, ref]) => {
      if (ref && ref.getPopup()) {
        if (name === activeMarkerName) {
          ref.openPopup();
        } else {
          ref.closePopup();
        }
      }
    });
  }, [activeMarkerName]);

  return (
    <MapContainer
      center={[28.5, -89.5]}
      zoom={7}
      style={{ height: "500px", width: "100%", borderRadius: "12px" }}
    >
      <TileLayer
        attribution="&copy; OpenStreetMap contributors & CartoDB"
        url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
      />
      {deployments.map((site, idx) => (
        <Marker
          key={idx}
          position={[site.lat, site.lng]}
          icon={markerIcon}
          ref={(ref) => {
            markerRefs.current[site.name] = ref;
          }}
          eventHandlers={{
            click: () => {
              if (onMarkerClick) {
                onMarkerClick(site.name);
              }
            },
          }}
        >
          <Popup>{site.name}</Popup>
        </Marker>
      ))}
    </MapContainer>
  );
}

SharpWatchMap.propTypes = {
  activeMarkerName: PropTypes.string,
  onMarkerClick: PropTypes.func,
};
